import {
  POST_MESSAGE,
  SHOW_WAIT,
  HIDE_WAIT,
  ON_FOCUS_INPUT,
  ON_BLUR_INPUT,
  UPDATE_HAS_INPUT_VALUE,
  UPDATE_LAST_USER_MESSAGE_POSTED_AT_MS,
  SET_TIMEOUT_STREAM,
} from '../../actions/input-field/index';

export const initialState = {
  showWait: false,
  isInputFocused: false,
  hasInputValue: false,
  lastUserMessagePostedAtMs: Date.now(),
  timeoutStream: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case POST_MESSAGE:
    case SHOW_WAIT:
      return toggleWait(state, action.show);
    case HIDE_WAIT:
      return toggleWait(state, action.show);
    case SET_TIMEOUT_STREAM:
      return { ...state, timeoutStream: action.value }
    case ON_FOCUS_INPUT:
      return toggleFocusOnInput(state, action.isInputFocused);
    case ON_BLUR_INPUT:
      return toggleFocusOnInput(state, action.isInputFocused);
    case UPDATE_HAS_INPUT_VALUE:
      return { ...state, hasInputValue: action.hasInputValue };
    case UPDATE_LAST_USER_MESSAGE_POSTED_AT_MS:
      return { ...state, lastUserMessagePostedAtMs: action.postedAtMs };
  }
  return state;
}

function toggleWait(state, show) {
  return {...state, showWait: show};
}

function toggleFocusOnInput(state, isInputFocused) {
  return { ...state, isInputFocused };
}
